import { InputText } from 'primereact/inputtext';
import { useCallback, useContext, useEffect, useState } from 'react';
import { Checkbox } from 'primereact/checkbox';
import { AdminContext } from '../../contexts/AdminContext';
import { RegNumSearchItem } from './RegNumSearchItem';
import { checkIsOpenForAccepting, checkIsOpenForRegister } from '../services/RankingService';
import { AuthContext } from '../../contexts/AuthContext';
import { CircleSpinnerOverlay } from "react-spinner-overlay";
import * as request from '../lib/lib';
import { ParameterContext } from '../../contexts/ParameterContext';

export const AdminSearchApplications = ({ action }) => {
    const [isOpenForAccepting, setIsOpenForAccepting] = useState(true);
    const [isOpenForRegister, setIsOpenForRegister] = useState(false);
    const { user } = useContext(AuthContext);
    const [loading, setLoading] = useState(false);
    const [recentRanking, setRecentRanking] = useState(null);
    const { parameters } = useContext(ParameterContext);

    let openForMun;

    if (parameters && parameters.nomParameters) {
        const openForMunParam = parameters.nomParameters.find(x => x.param_name == 'OPEN_FOR_MUN');

        openForMun = openForMunParam ? openForMunParam.value : 0;
    } else {
        openForMun = 0;
    }

    const filterTexts = {
        childEgn: 'ЕГН на дете',
        childName: 'име на дете',
        regNumber: 'номер на заявление',
    }

    const [filterOptions, setFilterOptions] = useState({
        isHaveSchoolInWishes: false,
        registerByMe: false,
        childEgn: false,
        childName: false,
        regNumber: true,
        schoolId: action == 'edit' ? null : user.role == 'Director' ? user.school.id : null,
        userId: user.role == 'Director' ? user.id : null,
        text: '',
        action: action
    });
    const { regNums, searchRegNums, cleanRegNums } = useContext(AdminContext);

    useEffect(() => {
        if (filterOptions.registerByMe) {
            searchRegNums(filterOptions);
        } else if (filterOptions.isHaveSchoolInWishes) {
            let filter = { ...filterOptions };
            filter.schoolId = user.school.id;

            searchRegNums(filter);
        } else if (filterOptions.text.length > 0) {
            searchRegNums(filterOptions);
        }

    }, [filterOptions])


    //initial useEffect
    useEffect(() => {
        checkIsOpenForAccepting()
            .then((data) => {
                setIsOpenForAccepting(data);
            })
            .catch((err) => {
                console.log(err);
                setIsOpenForAccepting(false);
            })

        checkIsOpenForRegister()
            .then((data) => {
                if (openForMun == 1 && (user.role == 'Municipality' || user.role == 'Admin' || user.role == 'SuperAdmin')) {
                    setIsOpenForRegister(true);
                } else {
                    setIsOpenForRegister(data);
                }
            })
            .catch((err) => {
                console.log(err);
                setIsOpenForRegister(false);
            })

        request.get(process.env.REACT_APP_BACKEND_URL + 'Ranking/GetRecentRanking')
            .then((data) => {
                setRecentRanking(data);
            })

        if (action == 'confirm' || action == 'cancelAfterExpiredRanking') {
            setLoading(true);
            setTimeout(() => {
                searchRegNums({
                    isHaveSchoolInWishes: false,
                    childEgn: false,
                    childName: false,
                    regNumber: false,
                    schoolId: user.role == 'Director' ? user.school.id : null,
                    userId: user.role == 'Director' ? user.id : null,
                    text: '',
                    action: action
                });
            }, 500)
        } else {
            cleanRegNums();
        }
        setLoading(false)

    }, [])

    const handleCheckboxChange = (option) => {
        if (option == 'isHaveSchoolInWishes') {
            setFilterOptions((prevOptions) => ({
                ...prevOptions,
                registerByMe: false,
                [option]: !prevOptions[option],
            }));
        } else if (option == 'registerByMe') {
            setFilterOptions((prevOptions) => ({
                ...prevOptions,
                isHaveSchoolInWishes: false,
                [option]: !prevOptions[option],
            }));
        } else {
            setFilterOptions((prevOptions) => ({
                ...prevOptions,
                childEgn: false,
                childName: false,
                regNumber: false,
                [option]: true,
            }));
        }
    };

    const handleChange = (e) => {
        setFilterOptions(state => ({
            ...state,
            text: e.target.value
        }))
    };

    const cleanFilterOptions = () => {
        setFilterOptions(state => ({
            isHaveSchoolInWishes: false,
            childEgn: false,
            childName: false,
            regNumber: true,
            schoolId: action == 'edit' ? null : user.role == 'Director' ? user.school.id : null,
            userId: user.role == 'Director' ? user.id : null,
            text: '',
        }))
    }

    return (
        <>
            <CircleSpinnerOverlay loading={loading} color="#1c79c0" outerBorderOpacity={0.3} outerBorderWidth={6} />
            {!isOpenForAccepting && action == 'confirm'
                ? <div className="col-12">
                    <div className="overflow-auto card recent-sales p-5 p-4-mob">
                        <p className="text-danger h5">Системата е затворена за потвърждаване на прием.</p>
                    </div>
                </div>
                : isOpenForAccepting && action == 'cancelAfterExpiredRanking'
                    ? <div className="col-12">
                        <div className="overflow-auto card recent-sales p-5 p-4-mob">
                            <p className="text-danger h5">Системата все още е отворена за записване на деца.</p>
                        </div>
                    </div>
                    : <div className="col-12">
                        <div className="overflow-auto card recent-sales p-5 p-4-mob">
                            <div className="form-group mb-2 d-flex flex-column flex-wrap gap-4">
                                {user.role == 'Director' &&
                                    <div className="d-flex w-50 w-80-l justify-content-between align-items-center flex-wrap w-100-mob gap-2">
                                        <label className="h6 w-100">Филтър:</label>
                                        <div className="d-flex gap-2">
                                            <Checkbox
                                                inputId="isHaveSchoolInWishes"
                                                onChange={() => handleCheckboxChange('isHaveSchoolInWishes')}
                                                checked={filterOptions.isHaveSchoolInWishes}
                                            />
                                            <label htmlFor="isHaveSchoolInWishes" >
                                                Съдържащи {user.school.name} в желанията си
                                            </label>
                                        </div>
                                        <div className="d-flex gap-2">
                                            <Checkbox
                                                inputId="registerByMe"
                                                onChange={() => handleCheckboxChange('registerByMe')}
                                                checked={filterOptions.registerByMe}
                                            />
                                            <label htmlFor="registerByMe">
                                                Регистрирани от мен
                                            </label>
                                        </div>
                                    </div>
                                }
                                <div className="d-flex w-30 w-60-l justify-content-between align-items-center flex-wrap w-100-mob gap-2">
                                    <label className="h6 w-100">Търсене по:</label>
                                    <div className="d-flex gap-2">
                                        <Checkbox
                                            inputId="regNumber"
                                            onChange={() => handleCheckboxChange('regNumber')}
                                            checked={filterOptions.regNumber}
                                        />
                                        <label htmlFor="parentEgn" >
                                            Номер на заявление
                                        </label>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <Checkbox
                                            inputId="childEgn"
                                            onChange={() => handleCheckboxChange('childEgn')}
                                            checked={filterOptions.childEgn}
                                        />
                                        <label htmlFor="childEgn">
                                            ЕГН на дете
                                        </label>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <Checkbox
                                            inputId="childName"
                                            onChange={() => handleCheckboxChange('childName')}
                                            checked={filterOptions.childName}
                                        />
                                        <label htmlFor="childName" >
                                            Име на дете
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <InputText name='text' id="searchText" style={{ width: '60%', marginBottom: '6%' }} value={filterOptions.text} className="w-100-mob w-100-l" onChange={handleChange} placeholder={`Търсене по ${filterTexts[
                                Object.keys(filterOptions).filter(key => key in filterTexts).find(key => filterOptions[key])
                            ]}`} />

                            <div className="d-flex flex-wrap justify-content-between align-items-center gap-1">
                                {regNums && regNums.map(x => <RegNumSearchItem key={x.regnumbeR_ID} regNum={x} action={action} recentRanking={recentRanking} cleanFilterOptions={cleanFilterOptions} isOpenForAccepting={isOpenForAccepting} isOpenForRegister={isOpenForRegister} />)}
                            </div>
                        </div>
                    </div>
            }
        </>
    )
}
